import { render, staticRenderFns } from "./printDemo.vue?vue&type=template&id=bbf14a40"
import script from "./printDemo.vue?vue&type=script&lang=js"
export * from "./printDemo.vue?vue&type=script&lang=js"
import style0 from "./printDemo.vue?vue&type=style&index=0&id=bbf14a40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports